import {css, StyleDeclaration, StyleSheet} from 'aphrodite';
import React from 'react';

import {BenchlingAppSessionStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {BLUE_LIGHT, GREEN_DARK, ORANGE, RED_DARK} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

const styles = StyleSheet.create({
  statusIcon: {
    marginRight: '6px',
  },
  wideCell: {
    columnSpan: 'all',
  },
});

const iconStyles = StyleSheet.create({
  info: {
    color: BLUE_LIGHT,
  },
  success: {
    color: GREEN_DARK,
  },
  warning: {
    color: ORANGE,
  },
  error: {
    color: RED_DARK,
  },
});

interface StatusIcons {
  icon: BenchlingIconName;
  style: StyleDeclaration;
  label: string;
}

export const STATUS_ICONS: Record<BenchlingAppSessionStatus, StatusIcons> = {
  [BenchlingAppSessionStatus.COMPLETED_WITH_WARNINGS]: {
    icon: 'warning',
    style: iconStyles.warning,
    label: 'Completed with warnings',
  },
  [BenchlingAppSessionStatus.FAILED]: {
    icon: 'error',
    style: iconStyles.error,
    label: 'Failed',
  },
  [BenchlingAppSessionStatus.RUNNING]: {
    icon: 'request-in-progress',
    style: iconStyles.info,
    label: 'Running',
  },
  [BenchlingAppSessionStatus.SUCCEEDED]: {
    icon: 'done',
    style: iconStyles.success,
    label: 'Completed',
  },
  [BenchlingAppSessionStatus.TIMEOUT]: {
    icon: 'cancelled',
    style: iconStyles.error,
    label: 'Timed out',
  },
};

interface StatusCellProps {
  status: BenchlingAppSessionStatus;
  dataTestAttrs: DataTestAttrs;
}

export default function BenchlingAppSessionStatusCell(props: StatusCellProps): JSX.Element {
  const icon = STATUS_ICONS[props.status];
  return (
    <div {...getTestProps(props.dataTestAttrs)}>
      <BenchlingIcon icon={icon.icon} className={css(styles.statusIcon, icon.style)} />
      {icon.label}
    </div>
  );
}
